import { NullablePartial } from "@ac-expo/api-types";
import { z } from "zod";

export const connectIdSchema = z.union([
  z.string().length(0, "L'ID Connect'Events n'est pas valide"),
  z.string().length(10),
]);

export const defaultConnectId = "";

export type ConnectIdForm = z.infer<typeof connectIdSchema>;

export const fromConnectIdSchema = z.object({
  connectId: connectIdSchema,
});

export type FromConnectIdForm = z.infer<typeof fromConnectIdSchema>;

export const defaultFromConnectIdValues = {
  connectId: defaultConnectId,
};

export const addVisitorFromDataSchema = z.object({
  firstName: z.string().max(64, "Veuillez entrer un prénom valide"),
  lastName: z.string().max(64, "Veuillez entrer un nom valide"),
  email: z.string().email("Email invalide"),
  zipCode: z.string().nullish(),
});

export type AddVisitorFromDataForm = z.infer<typeof addVisitorFromDataSchema>;

// these fields are nullable due to shared information
type NullableVisitorsFields = "firstName" | "lastName" | "email";

export type PartialAddVisitorFromDataForm = Omit<
  AddVisitorFromDataForm,
  NullableVisitorsFields
> &
  NullablePartial<Pick<AddVisitorFromDataForm, NullableVisitorsFields>>;

export type PartialAddVisitorFromDataFormWithIndex =
  PartialAddVisitorFromDataForm & {
    importedIndex: number;
  };

export const defaultAddVisitorFromDataValues = {
  firstName: "",
  lastName: "",
  email: "",
  zipCode: null,
};

export const importOrganiserVisitorsSchema = z.object({
  visitors: z.array(
    addVisitorFromDataSchema.extend({ importedIndex: z.number() })
  ),
});

export const defaultImportOrganiserVisitorsValues = {
  visitors: [],
};

export type ImportOrganiserVisitorsForm = z.infer<
  typeof importOrganiserVisitorsSchema
>;
